import { inject, Injectable } from '@angular/core'

import { ApiService } from '@ti/core/api'
import { NewPasswordViewModel } from '@ti/shared/auth-ui/models'

@Injectable()
export class FleetNewPasswordViewModel extends NewPasswordViewModel {
  protected readonly api = inject(ApiService)

  protected async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await this.api.fleet.user.changePassword(currentPassword, newPassword)
  }

  protected async confirmPasswordReset(password: string, secret: string): Promise<void> {
    await this.api.fleet.user.confirmPasswordReset(password, secret)
  }
}
